import React from "react";
import { Phone, ExternalLink } from "lucide-react";

const LOGO_URL =
  "https://customer-assets.emergentagent.com/job_ricochet-savings/artifacts/fnyt4egh_Ricochet%20logo%202018%20crop.png";

export const Header = () => {
  return (
    <header
      className="w-full bg-white border-b border-slate-200 sticky top-0 z-40"
      data-testid="site-header"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-20 sm:h-24">
          {/* Logo */}
          <a
            href="https://www.ricochetfuel.com"
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center gap-3 group"
            data-testid="header-logo-link"
          >
            <img
              src={LOGO_URL}
              alt="Ricochet Fuel Distributors, Inc."
              className="h-14 sm:h-16 w-auto object-contain"
              data-testid="header-logo-img"
            />
          </a>

          {/* Right side actions */}
          <div className="flex items-center gap-2 sm:gap-3">
            <a
              href="tel:+18339255065"
              className="hidden sm:inline-flex items-center gap-2 px-4 py-2.5 rounded-full text-sm font-semibold text-[#63499d] border-2 border-[#63499d]/20 hover:bg-[#63499d]/5 hover:border-[#63499d]/40 transition-colors"
              data-testid="header-phone-cta"
            >
              <Phone className="w-4 h-4" />
              <span>833-925-5065</span>
            </a>
            <a
              href="https://www.ricochetfuel.com"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 px-4 py-2.5 rounded-full text-sm font-semibold text-white bg-[#63499d] hover:bg-[#4d3884] transition-colors"
              data-testid="header-website-cta"
            >
              <span className="hidden sm:inline">Visit Main Site</span>
              <span className="sm:hidden">Visit Site</span>
              <ExternalLink className="w-4 h-4" />
            </a>
          </div>
        </div>
      </div>
    </header>
  );
};
